export const getRandomString = (length) => {
  if (length > 108 || length === 0)
    return "ERROR: Length must be between 0 and 108";
  const rawString =
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9) +
    Math.random().toString(36).substring(2, 9);
  const randomString = rawString.substring(4, length + 4);
  return randomString;
};

// console.log(getRandomString(20));

// for (i = 0; i < 100; i++) {
//   const rawString =
//     Math.random().toString(36).substring(2, 9) +
//     Math.random().toString(36).substring(2, 9) +
//     Math.random().toString(36).substring(2, 9) +
//     Math.random().toString(36).substring(2, 9);
//   const randomString = rawString.substring(4, 24);
//   console.log(randomString);
// }
